export enum FileType {
    Png,
    Pdf
}
